import { styled } from '@mui/material';
import { SecondaryButton } from 'src/components/Buttons/styles';

export const SocialButton = styled(SecondaryButton)`
    min-width: 32px;
    height: 32px;
`;
